import {
  SET_CAMPAIGN_STEPS,
  SET_CAMPAIGN,
  SET_CAMPAIGN_RULES,
  SET_CAMPAIGN_BASE_RULES,
  RESET_CAMPAIGN_RULES,
  RESET_CAMPAIGN_STATE,
} from "./types";

export const setCampaignSteps = (payload) => ({
  type: SET_CAMPAIGN_STEPS,
  payload,
});

export const setCampaign = (payload) => ({
  type: SET_CAMPAIGN,
  payload,
});

export const setCampaignRules = (payload) => ({
  type: SET_CAMPAIGN_RULES,
  payload,
  isUpdater: typeof payload === 'function'
});

export const setCampaignBaseRules = (payload) => ({
  type: SET_CAMPAIGN_BASE_RULES,
  payload,
});

export const resetCampaignRules = () => ({
  type: RESET_CAMPAIGN_RULES,
});

export const resetCampaignState = (payload = null) => ({
  type: RESET_CAMPAIGN_STATE,
  payload
});
